/* global System */
// register component(s) with react habitat

export default {
  calculator_roi: () => System.import('./index'),
}
